import { EpaValidator } from './epaValidator';
import { registeredVneValidator } from './vne';
import { registeredPesticidesValidator } from './pesticides';

export const registeredEpaValidator = new EpaValidator([
  registeredVneValidator,
  registeredPesticidesValidator,
]);
